const getState = state => state.modal

const isVideoCallVisibleSelector = state => getState(state)?.videoCallPromptModal?.show || getState(state)?.videoRoomModal?.show

const modalSelectors = {
  isVideoCallVisibleSelector
}

export default modalSelectors
